define('recruit-modal/recruit-modal',['require','knockout','web-urls','i18next','plugins/dialog','recruit-modal/recruit-done-modal','api-access','api-access','shared-g2m-logic'],function (require) {
    var ko = require('knockout');
    var webUrls = require('web-urls');
    var i18n = require('i18next');
    var dialog = require('plugins/dialog');
    var RecruitDoneModal = require('recruit-modal/recruit-done-modal');
    var userApi = require('api-access').user;
    var commerceApi = require('api-access').commerce;
    var Products = require('shared-g2m-logic').Products;

    var RecruitModal = function () {
        var self = this;

        self.firstName = ko.observable();

        self.schedule = function () {
            userApi.updateSettings({interviewAccepted: true});
            dialog.close(self);
            RecruitDoneModal.show();
        };

        self.close = function () {
            dialog.close(self);
        };

        self.activate = function () {
            return userApi.me().then(function (userMe) {
                self.firstName(userMe.firstName);
            });
        };
    };

    // Creates a custom dialog format
    var addDialogContext = function () {
        dialog.addContext('recruit', {
            addHost: function (theDialog) {
                var body = $('body');

                var host = $('<div class=""></div>')
                    .css({
                        'z-index': dialog.getNextZIndex(),
                        position: 'fixed',
                        bottom: '20px',
                        left: '20px'
                    })
                    .addClass('animated fadeInUp')
                    .appendTo(body);

                theDialog.host = host.get(0);
            },
            removeHost: function (theDialog) {
                $(theDialog.host).removeClass('animated fadeInUp');
                $(theDialog.host).addClass('animated fadeOutDown');

                var animationEvents = 'webkitAnimationEnd mozAnimationEnd' +
                    'MSAnimationEnd oanimationend animationend';
                $(theDialog.host)
                    .one(animationEvents, function () {
                        setTimeout(function () {
                            ko.removeNode(theDialog.host);
                        }, 200);
                    });
            },
            compositionComplete: function () {}
        });
    };

    RecruitModal.show = function () {
        var isEnLocale = i18n.lng().indexOf('en') > -1;
        if (isEnLocale && webUrls.get('showRecruitmentModal') === 'true') {
            userApi.me().then(function () {
                commerceApi.getProducts().then(function (productsResp) {
                    var products = new Products(productsResp);
                    var isPaid = !products.findExpiringTrial() && products.findActiveG2m().product === 'GoToMeeting';
                    if (isPaid) {
                        addDialogContext();

                        setTimeout(function () {
                            dialog.show(new RecruitModal(), {}, 'recruit');
                        }, 30000);
                    }
                });
            });
        }
    };

    return RecruitModal;
});

